export { SignUp as default } from './sign-up';
